var map = {
	"./de/bg.jpg": "8G7l",
	"./en/bg.jpg": "BQMT",
	"./es/bg.jpg": "QMWW",
	"./fr/bg.jpg": "Hzru",
	"./ja/bg.jpg": "0TNh",
	"./ko/bg.jpg": "W6Nt",
	"./pt/bg.jpg": "DmrH",
	"./ru/bg.jpg": "MfCA",
	"./tc/bg.jpg": "ZT/L",
	"./th/bg.jpg": "SsLc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BpDN";